<template>
    <page-container2 :title="pageTitle" :useCard="false" showRefreshButton @refresh="refresh">
        <template v-slot:buttons>
            <permission-container permissionId="Erp.AfterSale.Add">
                <el-button type="primary" size="mini" @click="add">添加售后单</el-button>
            </permission-container>
<!--                <el-button type="primary" size="mini" @click="exportOrder">导出</el-button>-->
            <!-- <permission-container >
                <el-button type="primary" size="mini" plain @click="exportPurchaseBill" :disabled="exportExcelBtnDisabled">导出</el-button>
            </permission-container> -->
        </template>
        <permission-container showTip permissionId="Erp.AfterSale.List">
        <search-form class="search-form-card" :table-list="tableList">
            <template v-slot:form-items>
                <el-form-item label="">
                    <ClientSelectList
                        style="width: 192px;"
                        v-model="tableList.searchForm.customerId"
                        :tableList="clientPageList"
                        :loading="clientSelectLoading"
                        :onSearch="handleSearchClients" ></ClientSelectList>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="tableList.searchForm.aftersaleCode" placeholder="退货单号" clearable @keyup.enter.native="tableList.load();"></el-input>
                </el-form-item>
                <el-form-item >
                    <el-date-picker
                        style="width: 240px;"
                        v-model="returnDateRange"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="退货日期开始"
                        end-placeholder="退货日期结束"
                        @change="onReturnDateChange"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="tableList.searchForm.productName" placeholder="货物名称" clearable @keyup.enter.native="tableList.load();"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="tableList.searchForm.spec" placeholder="规格" clearable @keyup.enter.native="tableList.load();"></el-input>
                </el-form-item>
                <!-- <el-form-item label="">
                    <el-select v-model="tableList.searchForm.state" clearable placeholder="订单状态"
                        style="width: 130px;">
                        <el-option
                            v-for="item in orderStateList"
                            :key="item.value"
                            :label="item.caption"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item> -->
            </template>
        </search-form>
        <card-table
            cardTableStyle="font-size: 12px; color: #333333;"
            ref="listTable"
            :tableList="tableList"
            :columns="[{
                prop: 'customer',
                label: '客户',
                headerSpan: 3,
                span: 3,
                style: 'word-wrap: break-word;'
            },{
                prop: 'type',
                label: '售后类型',
                headerSpan: 1,
                span: 1,
                style: 'width:80px',
            },{
                prop: 'aftersaleCode',
                label: '退货单号',
                headerSpan: 3,
                span: 3,
                style: 'word-wrap: break-word;width:160px'
            },{
                prop: 'returnDate',
                label: '退货日期',
                headerSpan: 3,
                span: 2,
            },{
                prop: 'productList',
                label: '产品',
                headerSpan: 4,
                span: 12,
                style: 'word-wrap: break-word;'
            },{
                prop: 'spec',
                label: '规格',
                headerSpan: 2,
                span: 0,
            },{
                prop: 'num',
                label: '数量',
                headerSpan: 2,
                span: 0,
            },{
                prop: 'amount',
                label: '金额',
                headerSpan: 2,
                span: 0,
            },{
                prop: 'state',
                label: '状态',
                headerSpan: 1,
                span: 1,
                style: 'text-align: center;',
            },{
                prop: 'createTime',
                label: '创建时间',
                headerSpan: 1,
                span: 1,
                style: 'text-align: center; width:150px',
            },{
                prop: 'buttons',
                label: '操作',
                headerSpan: 1,
                span: 1,
                style: 'text-align: center;width:140px;line-height: 2.1em;',
            }]">
            <template v-slot:custom-column-customer="slotProps">
                <div>{{slotProps.rowData.customerName}}（{{slotProps.rowData.customerCode}}）</div>
            </template>
            <template v-slot:custom-column-returnDate="slotProps">
                <date-render :value="slotProps.rowData.returnDate"/>
            </template>
            <template v-slot:custom-column-type="slotProps">
                <div>{{ slotProps.rowData.type == 1?'退货':'换货' }}</div>
            </template>
            <template v-slot:custom-column-productList="slotProps">
                <div v-for="(product, index) in slotProps.rowData.productList" class="order-product-item">
                    <div class="order-product-item-info" style="flex: 4;">
                        <span>名称：{{product.productName}}</span>
                        <span>编码：{{product.productCode}}</span>
                    </div>
                    <div class="order-product-item-info" style="flex: 2;">
                        <span>{{product.spec}}</span>
                    </div>
                    <div class="order-product-item-info" style="flex: 2;">
                        <span v-if="product.unitNum">{{product.unitNum}} {{product.unit}}</span>
                    </div>
                    <div class="order-product-item-info" style="flex: 2;">
                        <money-render :value="product.amount" :precision="2"/>
                    </div>
                </div>
            </template>
            <template v-slot:custom-column-state="slotProps">
                <order-state-render :state="slotProps.rowData.state"/>
            </template>
            <template v-slot:custom-column-creatTime="slotProps">
                <date-time-render :value="slotProps.rowData.createTime"></date-time-render>
            </template>
            <template v-slot:custom-column-buttons="slotProps">
                <permission-container permissionId="Erp.AfterSale.Detail">
                    <el-button size="mini"
                        @click="detail(slotProps.rowData, slotProps.$index)">详情</el-button>
                </permission-container>
                <permission-container permissionId="Erp.AfterSale.Edit">
                    <el-button size="mini" type="success" plain
                        @click="edit(slotProps.rowData, slotProps.$index)">修改</el-button>
                </permission-container>
                <permission-container permissionId="Erp.AfterSale.Delete">
                    <el-button
                        size="mini"
                        type="danger"
                        @click="deleteAftersale(slotProps.rowData, slotProps.$index)">删除</el-button>
                </permission-container>
            </template>
        </card-table>
        </permission-container>
    </page-container2>
</template>

<script>
import List from "@/components/table/List";
import lodash from 'lodash';
import SelectList from "../../../../components/select/SelectList";
export default
{
    name: "AfterSaleList",
    components: {SelectList},
    data()
    {
        return {
            tableList: new List({
                url: '/aftersale/list',
                searchForm: {
                    customerId: null,
                    type: null,
                    state: null,
                }
            }),
            orderStateList: [{value:1,caption:'正常'},{value: 9, caption: '已作废'}],
            OrderState: [],//top.Constant.OppiotSystem.OrderState,
            stateCount: {},
            // clientList: [],
            clientPageList: new List({
                url: '/customer/selectList',
                searchForm: {keywords: null},
            }),
            returnDateRange: '',
            orderDateRange: '',
            salesmanList: [],
            followerList: [],
            clientSelectLoading: false,
            SupplierSelectLoading: false,
            drafted: false,
            pageTitle: '售后单管理',
            SortByConstant: [
                { key: 'cTimeDesc', name: '最近创建在前', icon: 'el-icon-caret-bottom', },
                { key: 'cTimeAsc',  name: '最近创建在后', icon: 'el-icon-caret-top',},
                { key: 'uTimeDesc', name: '最近更新在前', icon: 'el-icon-caret-bottom',},
                { key: 'uTimeAsc', name: '最近更新在后', icon: 'el-icon-caret-top',},
            ]
        }
    },
    computed: {
        exportExcelBtnDisabled() {
            return !this.tableList.count;
        }
    },
    created()
    {
        // console.log("cookie >>>", Uiyee.getCookie());
        // this.tableList.searchForm.sortBy = Uiyee.getCookie('Oppiot_Order_List_Sort')||null;
    },
    mounted()
    {
        if(this.$route.query)
        {
            console.log("this.$route.query", this.$route.query);
            let {clientId, orderDeliveryDateBegin, orderDeliveryDateEnd} = this.$route.query;
            if (clientId)
                this.tableList.searchForm.clientId = parseInt(clientId);

            if (orderDeliveryDateBegin && orderDeliveryDateEnd)
            {
                let begin = parseInt(orderDeliveryDateBegin);
                let end = parseInt(orderDeliveryDateEnd);
                this.tableList.searchForm.orderDeliveryDateBegin = begin;
                this.tableList.searchForm.orderDeliveryDateEnd = end;
                this.deliveryDateRange = [begin, end];
            }

            // this.orderStateList = top.Constant.OppiotSystem.OrderState.EnumsList.filter(e => {
            //     if (this.drafted)
            //         return e.value == top.Constant.OppiotSystem.OrderState.Draft;
            //     return e.value != top.Constant.OppiotSystem.OrderState.Draft
            // });
        }

        return this.refresh().
        then(()=>
        {
            this.clientPageList.load();
            // this.supplierPageList.load();
        });
        // then(()=>this.loadSupplierList());
    },

    methods:
    {
        // loadClientList()
        // {
        //     return Oppiot.post("/Oppiot/Client/MyClientList", {page:1, pageSize: 9999}).
        //     then(response =>
        //     {
        //         if(response.isSuccess())
        //         {
        //             this.clientList = response.getData('list');
        //         }
        //         else
        //         {
        //             this.showMessageError(response.getErrorMessage());
        //         }
        //     });
        // },
        
        onDateChange(dateRange)
        {
            console.log("onDateChange >>>", dateRange);
            if(!dateRange)
            {
                dateRange = [null, null];
            }
            this.tableList.searchForm.orderDateBegin = dateRange[0];
            this.tableList.searchForm.orderDateEnd = dateRange[1];
        },
        onReturnDateChange(dateRange)
        {
            console.log("onDeliverDateChange >>>", dateRange);
            if(!dateRange)
            {
                dateRange = [null, null];
            }
            this.tableList.searchForm.returnDateBegin = dateRange[0];
            this.tableList.searchForm.returnDateEnd = dateRange[1];
        },
        loadCount()
        {
            return Fx.Http.post("/aftersale/count").
            then((resp)=>
            {
                if(resp.isSuccess())
                {
                    this.stateCount = resp.getData();
                }
            });
        },
        add()
        {
            let bridge = this.dispatchRouteTo('/erp/aftersale/edit');
            bridge.onRouteBack = ()=>
            {
                this.refresh();
            }
        },
        edit(rowData, index)
        {
            console.log(rowData, index);
            let bridge = this.dispatchRouteTo('/erp/aftersale/edit', {id: rowData.id});
            bridge.onRouteBack = ()=>
            {
                this.refresh();
            }
        },
        // copy(rowData, index)
        // {
        //     let bridge = this.dispatchRouteTo('/erp/order/edit', {copyOrderId: rowData.id, justCopy: true});
        //     bridge.onRouteBack = ()=>
        //     {
        //         this.refresh();
        //     }
        // },
        detail(rowData, index)
        {
            let bridge = this.dispatchRouteTo('/erp/aftersale/detail', {id: rowData.id});
            bridge.onRouteBack = ()=>
            {
                this.refresh();
            }
        },
        exportOrder()
        {

        },
        refresh()
        {
            return Fx.Promise.then(()=>
            {
                return this.$refs.listTable&&this.$refs.listTable.load();
            }).
            then(()=>
            {
                // return this.loadCount();
            });
        },
        
        toOrder(orderData)
        {
            this.dispatchOpenTab("/order/detail", {id: orderData.relateOrderId}, {caption:`订单-${orderData.relateOrderCode}`})
        },
        handleSearchClients(keywords) {
            const search = () => {
                this.clientSelectLoading = true;
                this.clientPageList.searchForm.keywords = keywords;
                this.clientPageList.load().then(() =>
                {
                    this.clientSelectLoading = false;
                    return this.clientPageList.data;
                });
            };

            lodash.debounce(search, 300)();
        },
        deleteAftersale(rowData, index)
        {
            console.log(rowData, index);
            return this.showConfirm("确定要删除售后单吗？").
            then((result)=>{
                if(!result) return;
                return Fx.Http.post("/aftersale/delete", {id: rowData.id}).
                then((resp)=>
                {
                    if(resp.isSuccess()) {
                        this.showMessageSuccess('删除成功', ()=>
                        {
                            this.tableList.load();
                        })
                    } else {
                        this.showMessageError(resp.getErrorMessage());
                    }
                })
            })
        },
    }
}
</script>

<style scoped lang="scss">
@import "~@/styles/common.scss";
.separator-top
{
    border-top: $border-style;
}
.separator-bottom
{
    border-bottom: $border-style;
}
.order-item-header
{
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
    padding-bottom: 5px;
    font-size: 12px;
}
.order-item-footer
{
    margin-top: 5px;
    display: flex;
    flex-direction: row;
    color: #999999;
}
.order-product-item:first-child
{
    border-top: none;
}
.order-product-item
{
    display: flex;
    flex-direction: row;
    padding: 5px 0px;
    border-top: $border-style;
    height: 100%;
}
.order-product-item-info
{
    display: flex;
    flex-direction: column;
    margin-left: 5px;
    justify-content: center;
}
.relate-order-info
{
    padding: 1px 5px;
    margin-left: 3px;
    border-radius: 3px;
    color: #ffffff;
    background-color: rgba(153, 102, 153, 1);
    height: 24px;
}
.relate-order-info.el-link.el-link--default
{
    color: #ffffff;
}

.demo-order
{
    padding: 1px 5px;
    margin-left: 3px;
    border-radius: 3px;
    color: #ffffff;
    background-color: #ff8e02;
}
</style>



// WEBPACK FOOTER //
// src/modules/erp/pages/aftersale/List.vue